export class Token {
    constructor(
        public idToken?: string,
        public accessToken?: string,
        public refreshToken?: string,
    ) {}
}
